module.exports = __webpack_public_path__ + "static/img/cate-icon3.142a833.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/cate-icon3.png
// module id = 91ip
// module chunks = 1